import {
  EuiButtonIcon,
  EuiContextMenuItem,
  EuiContextMenuPanel,
  EuiPopover,
} from "@inscopix/ideas-eui";
import { useState } from "react";
import { ModalUpdateTool } from "./ModalUpdateTool";
import { ToolVisibility } from "types/constants";
import { Tool } from "graphql/_Types";

interface ButtonToolActionsProps {
  id: Tool["id"];
  name: string;
  helpText: string;
  visibility: ToolVisibility;
}

export const ButtonToolActions = ({
  id,
  name,
  helpText,
  visibility,
}: ButtonToolActionsProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [modal, setModal] = useState<"edit" | "copy">();

  return (
    <>
      {modal === "edit" && (
        <ModalUpdateTool
          id={id}
          name={name}
          helpText={helpText}
          onClose={() => setModal(undefined)}
        />
      )}

      <EuiPopover
        isOpen={isPopoverOpen}
        closePopover={() => setIsPopoverOpen(false)}
        button={
          <EuiButtonIcon
            aria-label="Edit tool"
            iconType="gear"
            color="text"
            onClick={() => setIsPopoverOpen((isOpen) => !isOpen)}
          />
        }
      >
        <EuiContextMenuPanel
          size="s"
          items={[
            ...(visibility === ToolVisibility.PRIVATE
              ? [
                  <EuiContextMenuItem
                    key="edit"
                    icon="pencil"
                    onClick={() => {
                      setModal("edit");
                      setIsPopoverOpen(false);
                    }}
                  >
                    Edit
                  </EuiContextMenuItem>,
                ]
              : []),
          ]}
        />
      </EuiPopover>
    </>
  );
};
